export enum ArrowKeys {
  UP = 'up',
  DOWN = 'down',
  LEFT = 'left',
  RIGHT = 'right',
}

export type ArrowKey = ArrowKeys.UP | ArrowKeys.DOWN | ArrowKeys.LEFT | ArrowKeys.RIGHT